import * as React from 'react';
import { NotesPanelContent } from './NotesPanelContent';

export interface NotesPanelProps {
  ticket: string;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>,
  handleToggleDataEvents: () => void,
}

interface NotesPanelState {
  open: boolean;
  showDataEvents: boolean;
}

export class NotesPanel extends React.PureComponent<NotesPanelProps, NotesPanelState> {
  constructor(props: NotesPanelProps) {
    super(props);
    this.state = {
      open: false,
      showDataEvents: false,
    };
  }

  open = () => this.setState({ open: true });

  close = () => this.setState({ open: false });

  handleEmailTranscriptClick = () => {
    const { setShowModal } = this.props;
    setShowModal(true);
    this.close();
  };

  handleDataEventsClick = () => {
    const { handleToggleDataEvents } = this.props;
    const { showDataEvents } = this.state;
    handleToggleDataEvents();
    this.close();
    this.setState({ showDataEvents: !showDataEvents });
  };

  render() {
    const { ticket } = this.props;
    const { open, showDataEvents } = this.state;
    return (
      <div
        id="notesPanel"
        className={`ui-panel ui-panel-position-right ui-panel-display-overlay ui-body-inherit ui-panel-animate ui-panel-${open ? 'open' : 'close'}`}
      >
        <NotesPanelContent
          ticket={ticket}
          open={open}
          handlePressClose={this.close}
          handleEmailTranscriptClick={this.handleEmailTranscriptClick}
          handleDataEventsClick={this.handleDataEventsClick}
          showDataEvents={showDataEvents}
        />
      </div>
    );
  }
}
